import React, { useEffect } from 'react';
import ReactQuill from 'react-quill';

/**
 * Wrapper component for ReactQuill that suppresses findDOMNode deprecation warnings
 * ReactQuill internally uses findDOMNode which triggers React warnings in strict mode
 * This wrapper suppresses those warnings while maintaining functionality
 */
const ReactQuillWrapper = (props) => {
  // Suppress findDOMNode warning from ReactQuill in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const originalError = console.error;
      const originalWarn = console.warn;
      
      // Suppress findDOMNode warnings
      const suppressWarning = (...args) => {
        const message = args[0];
        if (
          typeof message === 'string' &&
          (message.includes('findDOMNode is deprecated') ||
           message.includes('Warning: findDOMNode'))
        ) {
          return; // Suppress this specific warning
        }
        originalWarn.apply(console, args);
      };

      console.warn = suppressWarning;
      console.error = (...args) => {
        const message = args[0];
        if (
          typeof message === 'string' &&
          (message.includes('findDOMNode is deprecated') ||
           message.includes('Warning: findDOMNode'))
        ) {
          return; // Suppress this specific error
        }
        originalError.apply(console, args);
      };

      return () => {
        console.warn = originalWarn;
        console.error = originalError;
      };
    }
  }, []);

  return <ReactQuill {...props} />;
};

ReactQuillWrapper.displayName = 'ReactQuillWrapper';

export default ReactQuillWrapper;

